export var icons = {};

// Track Control Icons

icons.toBeginning = (
  <svg
    class='icon-toBeginning'
    viewBox='0 0 24 24'
  >
    <g>
      <polygon points='7.9,12 20.5,3 20.5,21 	' />
      <path d='M20,3.9V12v8.1l-5.4-3.9L8.7,12l5.9-4.2L20,3.9 M21,2l-7,5l-7,5l7,5l7,5V12V2L21,2z' />
    </g>
    <g>
      <rect
        x='3.5'
        y='2.5'
        width='2'
        height='19'
      />
      <path d='M5,3v18H4V3H5 M6,2H3v20h3V2L6,2z' />
    </g>
  </svg>
);
icons.toEnd = (
  <svg
    class='icon-toBeginning'
    viewBox='0 0 24 24'
  >
    <g>
      <polygon points='3.5,3 16.1,12 3.5,21 	' />
      <path d='M4,3.9l5.4,3.9l5.9,4.2l-5.9,4.2L4,20.1V12V3.9 M3,2v10v10l7-5l7-5l-7-5L3,2L3,2z' />
    </g>
    <g>
      <rect
        x='18.5'
        y='2.5'
        width='2'
        height='19'
      />
      <path d='M20,3v18h-1V3H20 M21,2h-3v20h3V2L21,2z' />
    </g>
  </svg>
);

// Circled Button Icons

icons.blank = (
  <svg
    class='icon-blank'
    viewBox='0 0 48 48'
  >
    <circle
      cx='24'
      cy='24'
      r='23'
    />
  </svg>
);
icons.pitch = (
  <svg
    class='icon-pitch'
    viewBox='0 0 48 48'
  >
    <circle
      cx='24'
      cy='24'
      r='23'
    />
    <path
      d='M36,15c-0.7-1.3-2.5-2.3-5.9-3.2c-2.5-0.7-3-1-3.7-2L25.8,9H25h-0.8v11.5V32l-0.8-0.5c-0.5-0.3-1.3-0.6-1.8-0.8
	c-0.8-0.3-1.1-0.3-2.8-0.3c-1.5,0-2.1,0.1-2.8,0.2c-1.9,0.5-3.4,1.3-4,2.2c-0.2,0.4-0.2,0.6-0.2,1.2c0.1,1.7,1.6,2.6,4.9,3
	c1.5,0.2,3.8,0.1,5.1-0.2c2.1-0.4,3.8-1.5,4.1-2.6c0.1-0.4,0.2-3.8,0.2-10.5v-10l0.8,0.3c0.7,0.3,1.8,0.7,4.5,1.6
	c1.1,0.3,2.1,1,2.4,1.6c0.2,0.6-0.2,1.5-0.8,2.2c-0.2,0.3-0.2,0.3,0,0.6c0.2,0.2,0.3,0.3,0.5,0.3c0.3,0,1.9-1.7,2.4-2.5
	C36.3,16.7,36.4,16,36,15z'
    />
  </svg>
);
icons.stop = (
  <svg
    class='icon-stop'
    viewBox='0 0 48 48'
  >
    <circle
      cx='24'
      cy='24'
      r='23'
    />
    <g>
      <rect
        x='13.001'
        y='13.001'
        width='21.997'
        height='21.999'
      />
      <path
        d='M34,14v20H14V14H34 M34.998,12H13.002C12.449,12,12,12.449,12,13.002v21.996C12,35.551,12.449,36,13.002,36h21.996
		C35.551,36,36,35.551,36,34.998V13.002C36,12.449,35.551,12,34.998,12L34.998,12z'
      />
    </g>
  </svg>
);

icons.reset = (
  <svg
    class='icon-reset'
    viewBox='0 0 48 48'
  >
    <circle
      cx='24'
      cy='24'
      r='23'
    />
    <path
      d='M24,9.3V4.7L15.8,12l8.2,7.3v-4.9c6,0,10.9,4.9,10.9,10.9c0,6-4.9,10.9-10.9,10.9s-10.9-4.9-10.9-10.9
	c0-1.5,0.3-2.8,0.8-4.1l-4.8-1.7C8.4,21.3,8,23.2,8,25.3c0,8.8,7.2,16,16,16s16-7.2,16-16C40,16.4,32.8,9.3,24,9.3z'
    />
  </svg>
);
icons.play = (
  <svg
    class='icon-play'
    viewBox='0 0 48 48'
  >
    <circle
      cx='24'
      cy='24'
      r='23'
    />
    <path
      d='M41.831,25.633L14.677,39.621
	C13.455,40.25,12,39.363,12,37.988l0-27.976c0-1.375,1.455-2.262,2.677-1.633l27.154,13.988
	C43.158,23.051,43.158,24.949,41.831,25.633z'
    />
    <polygon points='20.2,36 11.6,36 11.8,12 20.4,12 ' />
    <polygon points='35.8,36 28,36 28.2,12 36,12 ' />
  </svg>
);
icons.pause = (
  <svg
    class='icon-pause'
    viewBox='0 0 48 48'
  >
    <circle
      cx='24'
      cy='24'
      r='23'
    />
    <polygon points='19.9,36 8.1,36 8.3,12 20.1,12 ' />
    <polygon points='37.2,36 25.4,36 25.6,12 37.4,12 ' />
  </svg>
);
icons.volume = (
  <svg
    class='icon-volume'
    viewBox='0 0 48 48'
  >
    <circle
      cx='24'
      cy='24'
      r='23'
    />
    <polygon
      stroke-width='2'
      points='18.5,11 18.5,37 14.333,30.783 6,30.783 6,17.217
	14.333,17.217 '
    />
    <path
      class='max-volume'
      stroke-width='2'
      stroke-linecap='round'
      d='M27,43
	c8.851-2.601,14.973-7.696,15-19c0.022-9.34-7.352-17.274-15-19'
    />
    <path
      class='mid-volume'
      stroke-width='2'
      stroke-linecap='round'
      d='M25,37
	c6.232-1.217,9.915-7.051,10-13c0.09-6.246-4.624-11.763-10-13'
    />
    <path
      class='low-volume'
      stroke-width='2'
      stroke-linecap='round'
      d='M23,28c2.209,0,4-1.791,4-4
	s-1.791-4-4-4'
    />
  </svg>
);

icons.download = (
  <svg
    class='icon-download'
    viewBox='0 0 48 48'
  >
    <circle
      cx='23.5'
      cy='23.5'
      r='23'
      stroke-miterlimit='10'
    />

    <polygon
      stroke-miterlimit='10'
      points='17.7,3 17.7,24.7 10.9,24.7 24,46.3 37.1,24.7 30.3,24.7 30.3,3 		'
    />
  </svg>
);

icons.speed = (
  <svg
    class='icon-speed'
    viewBox='0 0 48 48'
  >
    <circle
      cx='24'
      cy='24'
      r='23'
    />

    <g>
      <path
        d='M11,24c0,0.68,0.07,1.35,0.17,2H8.1C8.05,26,8,25.95,8,25.9v-3.8C8,22.05,8.05,22,8.1,22h3.07C11.07,22.65,11,23.32,11,24
			z'
      />
      <path
        d='M16.34,34.49l-2.17,2.16c-0.04,0.04-0.1,0.04-0.14,0l-2.68-2.68c-0.04-0.04-0.04-0.1,0-0.14l2.16-2.17
			C14.3,32.74,15.26,33.7,16.34,34.49z'
      />
      <path
        d='M26,36.83v3.07c0,0.05-0.05,0.1-0.1,0.1h-3.8c-0.05,0-0.1-0.05-0.1-0.1v-3.07c0.65,0.1,1.32,0.17,2,0.17
			S25.35,36.93,26,36.83z'
      />
      <path
        d='M36.65,33.83c0.04,0.04,0.04,0.1,0,0.14l-2.68,2.68c-0.04,0.04-0.1,0.04-0.14,0l-2.17-2.16c1.08-0.79,2.04-1.75,2.83-2.83
			L36.65,33.83z'
      />
      <path
        d='M40,22.1v3.8c0,0.05-0.05,0.1-0.1,0.1h-3.07c0.1-0.65,0.17-1.32,0.17-2s-0.07-1.35-0.17-2h3.07C39.95,22,40,22.05,40,22.1
			z'
      />
      <path
        d='M36.65,14.17l-2.16,2.17c-0.79-1.08-1.75-2.04-2.83-2.83l2.17-2.16c0.04-0.04,0.1-0.04,0.14,0l2.68,2.68
			C36.69,14.07,36.69,14.13,36.65,14.17z'
      />
      <path d='M22.1,8h3.8C25.95,8,26,8.05,26,8.1v3.07c-0.65-0.1-1.32-0.17-2-0.17s-1.35,0.07-2,0.17V8.1C22,8.05,22.05,8,22.1,8z' />
      <path
        d='M14.17,11.35l2.17,2.16c-1.08,0.79-2.04,1.75-2.83,2.83l-2.16-2.17c-0.04-0.04-0.04-0.1,0-0.14l2.68-2.68
			C14.07,11.31,14.13,11.31,14.17,11.35z'
      />
    </g>

    <g>
      <path
        d='M11.17,22H8.1
			C8.05,22,8,22.05,8,22.1v3.8C8,25.95,8.05,26,8.1,26h3.07'
      />
      <path
        d='M36.83,26h3.07
			c0.05,0,0.1-0.05,0.1-0.1v-3.8c0-0.05-0.05-0.1-0.1-0.1h-3.07'
      />
      <path
        d='M34.49,16.34l2.16-2.17
			c0.04-0.04,0.04-0.1,0-0.14l-2.68-2.68c-0.04-0.04-0.1-0.04-0.14,0l-2.17,2.16'
      />
      <path
        d='M13.51,31.66l-2.16,2.17
			c-0.04,0.04-0.04,0.1,0,0.14l2.68,2.68c0.04,0.04,0.1,0.04,0.14,0l2.17-2.16'
      />
      <path
        d='M26,11.17V8.1
			C26,8.05,25.95,8,25.9,8h-3.8C22.05,8,22,8.05,22,8.1v3.07'
      />
      <path
        d='M22,36.83v3.07
			c0,0.05,0.05,0.1,0.1,0.1h3.8c0.05,0,0.1-0.05,0.1-0.1v-3.07'
      />
      <path
        d='M36.83,22
			c-0.32-2.09-1.14-4.02-2.34-5.66'
      />
      <path
        d='M13.51,16.34
			c-1.2,1.64-2.02,3.57-2.34,5.66'
      />
      <path
        d='M11.17,26
			c0.32,2.09,1.14,4.02,2.34,5.66'
      />
      <path
        d='M31.66,13.51
			c-1.64-1.2-3.57-2.02-5.66-2.34'
      />
      <path
        d='M22,11.17
			c-2.09,0.32-4.02,1.14-5.66,2.34'
      />
      <path
        d='M34.49,31.66
			c1.2-1.64,2.02-3.57,2.34-5.66'
      />
      <path
        d='M26,36.83
			c2.09-0.32,4.02-1.14,5.66-2.34'
      />
      <path
        d='M16.34,34.49
			c1.64,1.2,3.57,2.02,5.66,2.34'
      />
      <path
        d='M36.83,26
			c0.1-0.65,0.17-1.32,0.17-2s-0.07-1.35-0.17-2'
      />
      <path
        d='M11.17,22
			c-0.1,0.65-0.17,1.32-0.17,2s0.07,1.35,0.17,2'
      />
      <path
        d='M34.49,16.34
			c-0.79-1.08-1.75-2.04-2.83-2.83'
      />
      <path
        d='M13.51,31.66
			c0.79,1.08,1.75,2.04,2.83,2.83'
      />
      <path
        d='M22,36.83
			c0.65,0.1,1.32,0.17,2,0.17s1.35-0.07,2-0.17'
      />
      <path
        d='M26,11.17
			c-0.65-0.1-1.32-0.17-2-0.17s-1.35,0.07-2,0.17'
      />
      <path
        d='M16.34,13.51l-2.17-2.16
			c-0.04-0.04-0.1-0.04-0.14,0l-2.68,2.68c-0.04,0.04-0.04,0.1,0,0.14l2.16,2.17'
      />
      <path
        d='M31.66,34.49l2.17,2.16
			c0.04,0.04,0.1,0.04,0.14,0l2.68-2.68c0.04-0.04,0.04-0.1,0-0.14l-2.16-2.17'
      />
      <path
        d='M16.34,13.51
			c-1.08,0.79-2.04,1.75-2.83,2.83'
      />
      <path
        d='M31.66,34.49
			c1.08-0.79,2.04-1.75,2.83-2.83'
      />
    </g>

    <g>
      <path
        d='M24.682,22.671l-0.692,2.828c0.003,0,0.007,0.001,0.01,0.001c0.828,0,1.5-0.672,1.5-1.5
		C25.5,23.419,25.166,22.92,24.682,22.671z'
      />
      <path d='M24,22.5c-0.828,0-1.5,0.672-1.5,1.5c0,0.528,0.275,0.991,0.688,1.258l0.868-2.753C24.036,22.505,24.019,22.5,24,22.5z' />
      <g>
        <polygon
          stroke-width='2'
          points='27.042,13.032 24.055,22.506 23.188,25.258 22.59,27.155 23.5,27.5 23.99,25.499 24.682,22.671 '
        />
        <path
          d='M27.119,12.712c-1.172,4.976-2.599,9.732-4.283,14.521c0,0-0.155-0.319-0.155-0.319l0.905,0.36
			c0,0-0.322,0.169-0.322,0.169C24.4,23.019,26.043,17.128,27.119,12.712L27.119,12.712z M27.132,12.668
			c-1.072,4.368-2.413,10.677-3.456,15.153c-0.169-0.062-0.992-0.357-1.178-0.424c0,0-0.226-0.081-0.226-0.081l0.071-0.238
			C23.691,22.346,25.312,17.179,27.132,12.668L27.132,12.668z'
        />
      </g>
    </g>
  </svg>
);

export default icons;
